import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  cardHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    paddingBottom: 10
  },
  statusChip: {},
  actionsDropdownMenu: {
    marginRight: -2,
    marginLeft: 'auto'
  },
  actionsListWrapper: {
    minWidth: 150
  }
})

export default useStyles
